<script setup lang="ts">
    import IconPhoto from '@/components/icons/IconPhoto.vue';
    import IconVector from '@/components/icons/IconVector.vue';
    import UploadImageModal from '@/components/UploadImageModal.vue';
    import { useConfigStore } from '@/store/config.store';
    import { useTemplateStore } from '@/store/template.store';
    import { getEmptyTextboxField } from '@/utils/emptyTemplate';
    import { storeToRefs } from 'pinia';
    import { ref } from 'vue';

    const emit = defineEmits<{
        close: [];
    }>();

    const { currentSide } = storeToRefs(useConfigStore());
    const templateStore = useTemplateStore();
    const isImageModalVisible = ref(false);

    function addTextField() {
        templateStore.addField({ ...getEmptyTextboxField(), side: currentSide.value });
        emit('close');
    }

    function addImageField() {
        isImageModalVisible.value = true;
    }
</script>

<template>
    <div>
        <div class="mb-4 flex items-center justify-between">
            <h3 class="text-lg font-bold">{{ $t('add_content') }}</h3>
        </div>

        <div class="mb-4">
            <div class="space-y-2">
                <button
                    class="flex w-full cursor-pointer items-center space-x-2 rounded px-3 py-2 text-left hover:bg-gray-200"
                    @click="addImageField"
                >
                    <div class="flex h-6 w-6 items-center justify-center">
                        <IconPhoto />
                    </div>
                    <span>{{ $t('add_image') }}</span>
                </button>

                <button
                    class="flex w-full cursor-pointer items-center space-x-2 rounded px-3 py-2 text-left hover:bg-gray-200"
                    @click="addTextField"
                >
                    <div class="flex h-6 w-6 items-center justify-center">
                        <IconVector />
                    </div>
                    <span>{{ $t('add_text') }}</span>
                </button>
            </div>
        </div>

        <UploadImageModal
            v-if="isImageModalVisible"
            @close="$emit('close')"
        />
    </div>
</template>
